import { router } from "@/router/core";
import { _get } from "@utils/utils";
import { redirect2Login } from "@utils/user";

// 进入路由前
router.onBefore = ({ _targetRoute }) => {
    // 当前页面需要登录
    if (_get(_targetRoute, 'meta.needLogin', null)) {
        if (redirect2Login()) {
            // 确认拦截跳转
            return false
        }
    }
}

// 进入路由后
router.onAfter = () => {

}

// 进入路由出现异常
router.onError = (options) => {
    // router.navigateTo({
    //     name: 'login'
    // })
    console.error('跳转异常', options)
}

export * from './core'
